module.exports = "/assets/b365753e78ffe7d7b563b4d87cbcbf0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8V.png
// module id = 2279
// module chunks = 0